"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _default = exports.default = {
  exportCostSlipUpload: {
    confirm: 'confirm',
    pleaseCheckData: 'Please select at least one data!',
    vvl: 'VVL',
    sailingDate: 'Sailing Date',
    toDate: 'To',
    bkNo: 'Bk No',
    blNo: 'B/L No.',
    feeState: 'Fee State',
    bankSlipState: 'Bank Slip State',
    applyInvoiceState: 'Apply Invoice State',
    pol: 'POL',
    pod: 'POD',
    tips: 'CNTAO only open Letter of Guarantee View function. If any problem, please contact relevant personnel of the corresponding port company.',
    timeFrame: 'The time range cannot exceed 31 days',
    cnshkEmploy: 'Only for use by Shekou (Shenzhen)',
    invoiceNo: 'Invoice No',
    InvoiceCurrency: 'Invoice Currency',
    cnyUsdBillingSeparately: 'CNY/USD billing separately',
    onlyCNY: 'Only CNY',
    invoiceWay: 'Invoice Way',
    paper: 'Paper invocie',
    electronics: 'electronic Invoice',
    soaNo: 'Soa No',
    invoiceNumber: 'Invoice Number',
    polNotNull: 'POL Not Null',
    taxpayerIdentificationNumber: 'Taxpayer Identification Number',
    address: 'Address',
    phone: 'Phone',
    bank: 'Bank',
    account: 'Account',
    consignee: 'Receive Email',
    bankUsd: 'Bank(USD)',
    accountUsd: 'Account(USD)',
    remark: 'Remark',
    taxpayerIdentificationNumberNotNull: 'Taxpayer Identification Number Not Null',
    addressNotNull: 'Address Not Null',
    phoneNotNull: 'Phone Not Null',
    bankNotNull: 'Bank Not Null',
    accountNotNull: 'Account Not Null',
    consigneeNotNull: 'Receive Email Not Null',
    invalidEmail: "Receive Email Format Error",
    invoiceStateValidate: 'The invoicing application can only be made when the invoice application is empty or rejected',
    invoiceStateValidate1: 'Please select the unbilled application data',
    amount: 'Amount',
    cnshkAndCncanValidate: 'The loading port is CNCAN/CNSHK, please operate in "Invoice Upload/Invoice application"',
    costStatusDetermination: 'The cost status is empty or confirmed',
    costStatusChange: 'The cost status changed successfully. Procedure',
    onlyCnshkUse: 'Only for use by Shekou (Shenzhen)',
    blNoFeesStateValidate: 'There is no bill of lading number or fee is not confirmed data, please select again',
    invoiceStateAcceptValidate: 'This B/L NO. has been applied for invoice and accepted, so there is no need to upload the bank slip. <br/> Our robot will automatically obtain payment information and cancel from an account in the background, please pay attention to the surrendered.',
    bankSlipNotArrive: 'Please select the data that has not arrived in the invoice',
    saveSuccessfully: 'Save Successfully',
    payeeContactShipping: "If you need to pay using a different payee name, please contact the shipping company first.",
    specialPaymentContact: "If you need to pay using a method other than the above, please email the shipping company for special handling.",
    updateInvoiceInfo: "If your company's invoicing information has been updated, please provide the contact email address displayed in the SO attachment.",
    onlyElectronicInvoice: 'Our company can only issue electronic invoices',
    updateEmailForInvoice: 'If the email for receiving electronic invoices has been updated, please contact the customer service email on the SO attachment',
    bankSlipUploadInstructions: "Bank Slip Upload Instructions:",
    uploadInstructions: 'Please upload the correct bank slip file. To improve the efficiency of releasing orders, the bank slip upload format has been set to PDF/JPG/PNG/BMP/TIFF. Content outside these file formats will be restricted from uploading. If you need to upload multiple files for a single reservation, please combine them into one PDF file. Thank you!',
    noRate: 'The exchange rate is not perfect, please contact the administrator!',
    inputVvlOrDataTime: 'Please input Vvl or Bk No or B/L No or SailingDate',
    notUploadFile: 'No bank slip attachment has been uploaded. Please confirm whether only invoicing is requested or not, and if invoicing is only requested, the earliest verification can be done the next day!',
    noSecondOpr: 'Secondary applications are not permitted.',
    CNTAODisable: 'The function is not applicable for port CNTAO.'
  },
  exportCostSlipUploadTable: {
    amount: 'Amount',
    feeState: 'Fee Status',
    bankSlipState: 'Bank Slip Status',
    paymentStatus: 'Payment Status',
    applyInvoiceState: 'Apply Invoice Status',
    bkNo: 'BK NO',
    blNo: 'BL NO',
    vesselCode: 'Vessel Code',
    voyageNo: 'Voyage No',
    voyageLeg: 'Voyage Leg',
    pol: 'POL',
    etdOrg: 'ETD Org',
    pod: 'POD',
    eta: 'ETA',
    etd: 'ETD',
    del: 'DEL',
    auditRemark: 'Bank Slip Audit Remark',
    auditRemark2: 'Invoice Audit Remark'
  }
};